/**
 * Seintje als een uitverkochte variant terug is.
 *
 * Twee dingen die dit anders maken dan een gewoon formulier:
 *
 * 1. De knop hangt aan de *gekozen variant*, niet aan het product. Een jurk in
 *    zes maten heeft er meestal twee uitverkocht; de knop hoort alleen te
 *    verschijnen bij die twee, en hij hoort van SKU te wisselen zodra de
 *    bezoeker een andere maat aanklikt. Vandaar dat we op de variant-wissel van
 *    het thema luisteren in plaats van één keer bij het laden te kijken.
 *
 * 2. De aanmelding gaat naar Voyado. Wij bewaren niets en versturen niets.
 */
(function () {
  var wortel = document.querySelector('[data-loyalty-bis]');
  if (!wortel) return;

  var brondata = document.querySelector('[data-bis-varianten]');
  var varianten = [];
  try {
    varianten = JSON.parse(brondata ? brondata.textContent : '[]');
  } catch (e) {
    return;
  }

  /* Het venster verplaatst zichzelf naar het einde van body zodra het
     verschijnt, dus zoeken we die onderdelen in het document en niet binnen de
     knop-container. */
  var verstuurKnop = document.querySelector('[data-bis-verstuur]');
  var emailVeld = document.querySelector('[data-bis-email]');
  var melding = document.querySelector('[data-bis-melding]');
  var maatregel = document.querySelector('[data-bis-maat]');
  var optIn = document.querySelector('[data-bis-optin]');
  var vak = document.querySelector('[data-bis-vak]');
  var geluktRegel = document.querySelector('[data-bis-gelukt]');
  if (!verstuurKnop) return;
  var teksten = {};
  var i18n = document.querySelector('[data-bis-i18n]');
  if (i18n) {
    try { teksten = JSON.parse(i18n.textContent); } catch (e) { teksten = {}; }
  }
  var huidigeSku = null;

  /* Fouten onder het formulier, want dat moet bruikbaar blijven. De regel
     blijft staan als hij leeg is: het vak is al gereserveerd in de opmaak, dus
     het venster verspringt niet zodra er iets verschijnt. */
  function toonFout(tekst) {
    melding.textContent = tekst || '';
  }

  /* Gelukt legt zich over het formulier heen, zonder het venster te verhogen. */
  function toonGelukt(tekst) {
    toonFout('');
    if (!vak || !geluktRegel) return;
    geluktRegel.textContent = tekst || '';
    vak.classList.add('is-klaar');
  }

  function herstel() {
    toonFout('');
    if (vak) vak.classList.remove('is-klaar');
  }

  /**
   * Welke variant staat er nu gekozen?
   *
   * Drie bronnen, in volgorde van betrouwbaarheid. Het thema zet bij een
   * maatwissel eerst de URL bij (replaceState) en daarna het verborgen
   * id-veld; bij het laden van de pagina staat er nog geen ?variant= in de URL
   * en is alleen dat veld gevuld. Als laatste redmiddel de eigen staat van
   * product-selector, want die weet het sowieso.
   */
  function gekozenId() {
    var uitUrl = new URLSearchParams(window.location.search).get('variant');
    if (uitUrl && /^\d+$/.test(uitUrl)) return Number(uitUrl);

    var velden = document.querySelectorAll('[name="id"]');
    for (var i = 0; i < velden.length; i++) {
      if (/^\d+$/.test(velden[i].value)) return Number(velden[i].value);
    }

    var kiezer = document.querySelector('product-selector');
    if (kiezer && kiezer.currentVariant && kiezer.currentVariant.id) {
      return Number(kiezer.currentVariant.id);
    }
    return null;
  }

  function ververs() {
    var id = gekozenId();
    var variant = null;
    for (var i = 0; i < varianten.length; i++) {
      if (varianten[i].id === id) { variant = varianten[i]; break; }
    }
    /* Zonder SKU heeft aanmelden geen zin: Voyado kent het artikel dan niet.
       Liever geen knop dan een knop die stil niets doet. */
    if (!variant || variant.available || !variant.sku) {
      wortel.hidden = true;
      huidigeSku = null;
      return;
    }
    /* Wisselt de bezoeker van maat, dan hoort de melding van de vorige maat
       weg. Anders staat er "gelukt" onder een maat waarvoor niets is gedaan. */
    if (variant.sku !== huidigeSku) {
      huidigeSku = variant.sku;
      herstel();
      if (maatregel) {
        var opties = variant.opties || [];
        maatregel.textContent = opties
          .map(function (o) { return o.naam + ': ' + o.waarde; })
          .join('  ·  ');
        maatregel.hidden = !maatregel.textContent;
      }
    }
    wortel.hidden = false;
  }

  async function meldAan() {
    if (!huidigeSku) return;
    var email = emailVeld ? emailVeld.value.trim() : '';
    if (emailVeld && !email) {
      toonFout(teksten.emailOntbreekt || '');
      emailVeld.focus();
      return;
    }

    verstuurKnop.disabled = true;
    verstuurKnop.setAttribute('data-pending', '');
    try {
      var res = await fetch('/apps/loyalty/backinstock', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          sku: huidigeSku,
          email: email || undefined,
          optIn: optIn ? optIn.checked : undefined
        })
      });
      var data = await res.json().catch(function () { return {}; });
      /* Het endpoint geeft bewust altijd 200: een 5xx wordt door de App Proxy
         vervangen door Shopify's eigen foutpagina en dan ziet de bezoeker
         helemaal niets van ons. Of het gelukt is staat in de body. */
      if (res.ok && data.aangemeld) {
        toonGelukt(data.alBekend ? (teksten.alBekend || '') : (teksten.gelukt || ''));
        if (emailVeld) emailVeld.value = '';
        if (optIn) optIn.checked = false;
      } else {
        toonFout(data.error || teksten.mislukt || '');
      }
    } catch (e) {
      toonFout(teksten.mislukt || '');
    }
    verstuurKnop.disabled = false;
    verstuurKnop.removeAttribute('data-pending');
  }

  verstuurKnop.addEventListener('click', meldAan);
  if (emailVeld) {
    emailVeld.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); meldAan(); }
    });
  }

  /*
   * Het thema wisselt van variant zonder de pagina te herladen. Welke gebeurtenis
   * dat precies is verschilt per thema-versie, dus we luisteren breed en vallen
   * terug op de geschiedenis-API, die bij elke maatwissel wordt bijgewerkt.
   */
  ['variant:change', 'variantChange', 'product:variant-change'].forEach(function (naam) {
    document.addEventListener(naam, ververs);
  });
  /* Het thema stuurt bij een maatwissel een bubbelende change op het verborgen
     id-veld. Dat is de betrouwbaarste seinpaal die er is. */
  document.addEventListener('change', function (e) {
    if (e.target && (e.target.name === 'id' || e.target.closest('product-selector'))) ververs();
  });
  window.addEventListener('popstate', ververs);
  var duwState = history.pushState;
  history.pushState = function () {
    duwState.apply(this, arguments);
    ververs();
  };
  var vervangState = history.replaceState;
  history.replaceState = function () {
    vervangState.apply(this, arguments);
    ververs();
  };

  ververs();
})();
